import { connect } from 'react-redux'
import FullListActiveTrips from '../../components/trips/list/FullListActiveTrips'
import * as actions from '../../state/actions/trips'
import { IStoreState, ITripFilters } from '../../types'

export function mapStateToProps(state: IStoreState): any {
  return {
    currentOrganizationId: state.organizations.currentOrgId,
    lastActiveTrips: state.trips.lastActiveTrips,
    trips: state.trips.items
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getActiveTrips: (organizationId: string, status: string, numberOfRecords: number) =>
      dispatch(actions.getActiveTrips(organizationId, status, numberOfRecords)),
    getLastActiveTrips: (filters: ITripFilters) => dispatch(actions.getLastActiveTrips(filters)),
    resendRequest: (tripId: string) => dispatch(actions.resendTripRequest(tripId)),
    getManyStatusesById: async (tripId: string) => actions.getManyStatusesById(tripId)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullListActiveTrips)



// WEBPACK FOOTER //
// ./src/containers/trips/FullListActiveTrips.ts